import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes } from 'react-router-dom';

import JobsListContextProvider from '../../../context/jobsListContext';
import ComposableDashboardContextProvider from '../../../features/analyticsPage/context/ComposableDashboardContext';
import ComposableDashboardFiltersContextProvider from '../../../features/analyticsPage/context/ComposableDashboardFiltersContext';
import ComposableDashboardsCollectionsContextProvider from '../../../features/analyticsPage/context/ComposableDashboardsCollectionContext';
import ComposableDynamicListingContextProvider from '../../../features/analyticsPage/context/ComposableDynamicListingContext';
import ErrorLogger from '../../../providers/ErrorLogger';
import RouteGuard from '../../../routes/RouteGuard';
import JobsCrmInsights from '../insights';
import JobsCrmListing from '../JobsCrmListing';

export const JobsCrmRoutes = () => (
  <Routes>
    <Route
      path="/:jobId/:openViewDetails/:defaultJDTab/:type*"
      element={
        <RouteGuard>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <ComposableDynamicListingContextProvider>
              <ComposableDashboardContextProvider>
                <ComposableDashboardsCollectionsContextProvider>
                  <ComposableDashboardFiltersContextProvider>
                    <JobsListContextProvider>
                      <JobsCrmListing />
                    </JobsListContextProvider>
                  </ComposableDashboardFiltersContextProvider>
                </ComposableDashboardsCollectionsContextProvider>
              </ComposableDashboardContextProvider>
            </ComposableDynamicListingContextProvider>
          </ErrorBoundary>
        </RouteGuard>
      }
    />
    <Route
      path="/:jobId/:openViewDetails/:defaultJDTab/:type/:encodedEmail*"
      element={
        <RouteGuard>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <ComposableDynamicListingContextProvider>
              <ComposableDashboardContextProvider>
                <ComposableDashboardsCollectionsContextProvider>
                  <ComposableDashboardFiltersContextProvider>
                    <JobsListContextProvider>
                      <JobsCrmListing />
                    </JobsListContextProvider>
                  </ComposableDashboardFiltersContextProvider>
                </ComposableDashboardsCollectionsContextProvider>
              </ComposableDashboardContextProvider>
            </ComposableDynamicListingContextProvider>
          </ErrorBoundary>
        </RouteGuard>
      }
    />
    <Route
      path="/:jobId/candidate-analytics"
      element={
        <RouteGuard>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <JobsListContextProvider>
              <JobsCrmInsights />
            </JobsListContextProvider>
          </ErrorBoundary>
        </RouteGuard>
      }
    />
  </Routes>
);
export const JobsCrmChildRoutes = () => (
  <Routes>
    {/* <Route path="/*" element={<JobsCrmSmartSource job={IJob} />} />
    <Route path="/candidate-similar-jobs" element={<JobsCrmSmartSource index={1} />} />
    <Route path="/candidate-analytics" element={<JobsCrmInsights />} />
    <Route path="/candidate-mappings" element={<JobsCrmPipeline />} /> */}
  </Routes>
);
